import type { TextosDoSegredoExibido } from '@/shared/components/ui';

import type { OpcaoDeEscopo } from '../types/chavesDeApiTypes';

/**
 * Ordem e texto da lista de escopos do formulário. Nenhum vem marcado (D10-10): quem cria decide
 * um a um o que a integração pode fazer. A escrita já inclui a leitura do mesmo recurso no core
 * (`escopoDaChave.ts`), por isso a descrição avisa em vez de a tela marcar a leitura sozinha.
 */
export const OPCOES_DE_ESCOPO: readonly OpcaoDeEscopo[] = [
  {
    escopo: 'arbitral:leitura',
    rotulo: 'Arbitral — leitura',
    descricao: 'Consultar os processos arbitrais do escritório.',
  },
  {
    escopo: 'arbitral:escrita',
    rotulo: 'Arbitral — escrita',
    descricao: 'Criar e alterar dados dos processos arbitrais. Inclui a leitura.',
  },
  {
    escopo: 'extrajudicial:leitura',
    rotulo: 'Extrajudicial — leitura',
    descricao: 'Consultar negociações extrajudiciais e agentes.',
  },
  {
    escopo: 'extrajudicial:escrita',
    rotulo: 'Extrajudicial — escrita',
    descricao: 'Criar e alterar negociações extrajudiciais e agentes. Inclui a leitura.',
  },
  {
    escopo: 'notificacoes:leitura',
    rotulo: 'Notificações — leitura',
    descricao: 'Consultar notificações e modelos, e validar o documento do destinatário.',
  },
  {
    escopo: 'notificacoes:escrita',
    rotulo: 'Notificações — escrita',
    descricao: 'Enviar notificações e alterar modelos. Inclui a leitura.',
  },
];

/** D10-2: a chave antiga vale 30 dias depois da rotação. Fixo no core; a tela só informa. */
export const DIAS_DE_SOBREVIDA = 30;

/** R1.2 do plano 18: o core aceita de 1 a 60 caracteres depois do trim. */
export const TAMANHO_MAXIMO_DO_NOME = 60;

export const TEXTOS_DA_CHAVE_EMITIDA: TextosDoSegredoExibido = {
  titulo: 'Chave criada',
  instrucao: 'Copie a chave agora e guarde no sistema do escritório. Ela não será exibida de novo.',
  avisoSemCopiar: {
    titulo: 'Você ainda não copiou a chave',
    descricao:
      'Depois de fechar, não há como ver esta chave de novo. Se ela se perder, será preciso rotacionar.',
  },
  dicaDeCopiaManual: 'Selecione o texto da chave e copie manualmente.',
  rotuloCopiado: 'Copiada',
};
